import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import Select, { IOption } from 'components/ui/abstract/Select'
import { ISetSearchParams, ITreatment } from 'components/core/types'
import { IApplicationState } from 'components/store/types'
import {
  getCurrentPersonType,
  getCurrentTreatmentId,
  getTreatments,
} from 'components/core/state/selectors'
import { AppDispatch } from 'components/store/state/store'
import { updateCurrentTreatment } from 'components/core/state/actions'
import { SelectChangeEvent } from '@mui/material/Select/SelectInput'
import { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'
import Spinner from 'components/ui/Spinner'

const formatTreatmentOptions = (treatments: ITreatment[], currentPersonType, t: TFunction): IOption[] => treatments
  .map(({
    id,
    name,
    description,
    except_kids,
  }: ITreatment) => {
    // const disabled = except_kids && currentPersonType === 3
    const disabled = false
    return {
      value: id,
      label: name + (disabled ? ` (${t('except-kids')})` : ''),
      tooltip: description,
      disabled,
    }
  })

const mapState = (state: IApplicationState) => ({
  treatments: getTreatments(state),
  currentTreatment: getCurrentTreatmentId(state),
  currentPersonType: getCurrentPersonType(state),
})
const mapDispatch = (dispatch: AppDispatch) => ({
  updateTreatment: (treatmentId: number, setSearchParams: ISetSearchParams) => {
    dispatch(updateCurrentTreatment(treatmentId, setSearchParams))
  },
})
const connector = connect(mapState, mapDispatch)

interface SelectTreatmentProps extends ConnectedProps<typeof connector> {
  big?: boolean,
}

const SelectTreatment = ({
  big,
  currentTreatment,
  currentPersonType,
  treatments,
  updateTreatment,
}: SelectTreatmentProps) => {
  const [, setSearchParams] = useSearchParams()
  const { t } = useTranslation()
  const [options, setOptions] = useState(formatTreatmentOptions(treatments, currentPersonType, t))
  const [selected, setSelected] = useState(currentTreatment)
  const handleChange = (event: SelectChangeEvent) => {
    updateValue(parseInt(event.target.value, 10))
  }
  useEffect(() => {
    setOptions(formatTreatmentOptions(treatments, currentPersonType, t))
    if (currentTreatment) {
      updateValue(currentTreatment)
    }
  }, [treatments, currentPersonType, currentTreatment])

  const updateValue = (newValue: number) => {
    console.log('updateValue', newValue, selected, options)
    if (options.length) {
      const newOption = options.filter((option) => option.value === newValue)
      console.log('newOption', newOption, newOption[0]?.disabled)
      if (newOption[0]?.disabled) {
        updateValue(options[0].value)
      }
    }
    if (newValue === selected) {
      return
    }
    setSelected(newValue)
    updateTreatment(newValue, setSearchParams)
  }

  if (!selected || !options.length) {
    return <Spinner />
  }
  return (
    <Select
      big={big}
      options={options}
      defaultValue={selected}
      onChange={handleChange}
    />
  )
}
SelectTreatment.defaultProps = {
  big: false,
}
export default connector(SelectTreatment)
